import { type Nullable, atomWithStorageWithDefault } from "@sunrise/utils";
import { type ChannelId } from "@sunrise/yallo-channel";

export const lastWatchedChannelIdAtom = atomWithStorageWithDefault<
  Nullable<ChannelId>
>("last-watched-channel-id", null);
